import {
    KNOWLEDGE_LIST_REQUEST,
    KNOWLEDGE_LIST_RESPONSE,
    KNOWLEDGE_LIST_CACHED_RESPONSE,
    KNOWLEDGE_LIST_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_REQUEST,
    KNOWLEDGE_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_CACHED_RESPONSE,
    KNOWLEDGE_ITEM_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_REQUEST,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_ERROR_RESPONSE,
    KNOWLEDGE_ANALYSE_REQUEST,
    KNOWLEDGE_ANALYSE_ERROR_RESPONSE
} from "./action-types"
import {
    listRequest,
    listResponse,
    listErrorResponse,
    listCachedResponse
} from "./default-actions/paging-actions"
import {
    itemSaveRequest,
    itemSaveErrorResponse,
    itemRequest,
    itemResponse,
    itemCachedResponse,
    itemErrorResponse
} from "./default-actions/entity-actions"

// Analyse actions
export const knowledgeAnalyseRequest = (
    data,
    dataType,
    shouldPersist,
    isSimple,
    callbackActionCreator
) => ({
    type: KNOWLEDGE_ANALYSE_REQUEST,
    data,
    dataType,
    shouldPersist,
    isSimple,
    callbackActionCreator
})

export const knowledgeAnalyseErrorResponse = (
    error,
    data,
    dataType,
    shouldPersist,
    callbackActionCreator
) => ({
    type: KNOWLEDGE_ANALYSE_ERROR_RESPONSE,
    error,
    data: {},
    dataType,
    shouldPersist,
    callbackActionCreator
})

// Entity actions
export const knowledgeItemSaveRequest = itemSaveRequest(
    KNOWLEDGE_ITEM_SAVE_REQUEST
)
export const knowledgeItemSaveResponse = itemResponse(
    KNOWLEDGE_ITEM_SAVE_RESPONSE
)
export const knowledgeItemSaveErrorResponse = itemSaveErrorResponse(
    KNOWLEDGE_ITEM_SAVE_ERROR_RESPONSE
)
export const knowledgeItemRequest = itemRequest(KNOWLEDGE_ITEM_REQUEST)
export const knowledgeItemResponse = itemResponse(KNOWLEDGE_ITEM_RESPONSE)
export const knowledgeItemCachedResponse = itemCachedResponse(
    KNOWLEDGE_ITEM_CACHED_RESPONSE
)
export const knowledgeItemErrorResponse = itemErrorResponse(
    KNOWLEDGE_ITEM_ERROR_RESPONSE
)

// Paging actions
export const knowledgeListRequest = listRequest(KNOWLEDGE_LIST_REQUEST)
export const knowledgeListResponse = listResponse(KNOWLEDGE_LIST_RESPONSE)
export const knowledgeListCachedResponse = listCachedResponse(
    KNOWLEDGE_LIST_CACHED_RESPONSE
)
export const knowledgeListErrorResponse = listErrorResponse(
    KNOWLEDGE_LIST_ERROR_RESPONSE
)
